import Link from "next/link";
import DirectionalArrow from "@/components/ui/DirectionalArrow";
import { cn } from "@/lib/utils";

type ArrowLinkProps = {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  className?: string;
};

export default function ArrowLink({
  href,
  children,
  external,
  className,
}: ArrowLinkProps) {
  const classes = cn(
    "group inline-flex items-center gap-2 text-sm font-medium text-foreground transition-colors hover:text-muted",
    className,
  );

  const content = (
    <>
      {children}
      <DirectionalArrow className="size-4" />
    </>
  );

  if (external) {
    return (
      <a
        href={href}
        className={classes}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }

  return (
    <Link href={href} className={classes}>
      {content}
    </Link>
  );
}
